<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center mb-10 pb-10">
        <v-flex xs12 sm8 md6 class="pb-10">
          <h3 class="text-center">{{ canEdit ? 'Edit Invoice' : 'Enter Transaction Details'}}</h3>
          <v-card>
            <v-card-title class="py-1">
              <v-btn small text outlined @click="goTo('/invoices/' + invoice.id)" title="Cancel">
                <v-icon left="">mdi-arrow-left</v-icon>Cancel
              </v-btn>
              <v-spacer></v-spacer>
              KShs. {{ invoice.net ? invoice.net.format() : invoice.net }}
            </v-card-title>
            <v-card-text>
              <invoice-edit-form :invoice="invoice" :canEdit="canEdit"></invoice-edit-form>
            </v-card-text>
            <v-card-actions class="py-0" v-if="canEdit">
              <p class="mb-0 text-muted">These are the only editable options. To edit the amount, please issue a negating invoice.
                <span v-if="invoice.net != 0">e.g This invoice is for KShs.{{ invoice.net }}, that would mean issuing an invoice for KShs.{{ -1 * invoice.net }}. This is usually the amount you also send back to the payee as a reversal.</span>
                <span v-else>This invoice can't be negated</span>
              </p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  const InvoiceEditForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "invoices" */ '@/Components/Invoices/edit')

  export default {
    name: 'EditInvoicePage',
    layout,
    props: [
      'invoice', 'canEdit',
    ],
    components: {
      InvoiceEditForm,
    },
    metaInfo () {
      return {
        title: 'Edit Invoice',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>
